import ccsonTileTypesJson from '@envclient/envengine/src/config/ccson/ccson_tilemap.json';
import ccsonTileCount from '@envclient/envengine/src/config/ccson/ccson_tilecount.json';
import koenigsburgTileCount from '@envclient/envengine/src/config/koenigsburg/koenigsburg_tilecount.json';

export interface NodeDef {
  id: number;
  type: string;
  x: number;
  y: number;
}

export interface TileDef {
  type: number;
  count?: number;
  sides: string;
  nodes: Array<NodeDef>;
  rot?: number;
}

const ccsonTileTypes: Record<number, TileDef> = ccsonTileTypesJson as Record<number, TileDef>;

const getTileDef = (type: number): TileDef => {
  return ccsonTileTypes[type];
};

export { ccsonTileCount, koenigsburgTileCount, getTileDef };
